module.exports = __webpack_public_path__ + "media/thanos_dust_6.c1b80089.mp3";